import React, {useState, useEffect, startTransition} from 'react';
import { FaPlus } from 'react-icons/fa';
import {
  TmoButtons as TmoButton,
  FormModal,
  TmoInput
} from '@tmobile/tmo-bps-syncup-web-component-lib';

import PageHeader from '../../components/uiHelpers/pageHeader/PageHeader';
import style from './DisplayRatePlans.module.css';
import { ReactSVG } from 'react-svg';
import close from '../../static/assets/icons/close_icon.svg';
import searchIcon from '../../static/assets/icons/help_search.svg';


function RatePlanHeader({ count, onAdd, formFieldSpecs, sendFilteredRes}) {
    const [searchInput, setSearchInput] = useState("");
    useEffect(() => {
        if (searchInput) {
            startTransition(() => {
         setSearchInput(searchInput);
        });
        }
         else{
          setSearchInput("");
         }
      }, [searchInput]);

  const handleOnSearch = (e) => {
      e.preventDefault();
      
      if (!searchInput) {
        return;
      }
      setSearchInput(searchInput);
      sendFilteredRes(searchInput);
    };
    const handleClose = () => {
      setSearchInput('');
      sendFilteredRes('');
  };
  return (
    <PageHeader
      primary
      title="Rate Plans"
      subtitle={count > 1 ? `${count} rate plans available` : null}
    >
      <div className={style.search_div_section}>
        <form onSubmit={handleOnSearch} className={style.search_section}>
        <ReactSVG src={searchIcon} className={style.search_icon} />
        <TmoInput
          className={style.search_input}
          size="lg"
          placeholder="Search by Plan Name"
          onChange={setSearchInput}
          value={searchInput}
          inputType="primary"
        />
        {searchInput && (
                 <ReactSVG
                   onClick={() => handleClose()}
                   className={style.close_icon}
                   src={close}
                 />
               )}
      </form>
      </div>
      <TmoButton type="magenta_primary" icon={<FaPlus />} onClick={onAdd}>
        Add New Rate Plan
      </TmoButton>
      <FormModal
        title="Add new Rate Plan"
        fieldSpecs={formFieldSpecs}
        modalType="slide"
      />
    </PageHeader>
  );
}

export default RatePlanHeader;
